import { FC } from "react";
import { Notification } from "@mantine/core";

const AuthRepInfo: FC = () => {
  return (
    <Notification
      withCloseButton={false}
      color="teal"
      style={{ marginBottom: "30px" }}
      title="Authorized Representative"
    >
      Please note that, as the Authorized Representative, he/she is authorized
      by the Board of Directors pursuant to a board resolution to execute all
      agreements on the platform.
    </Notification>
  );
};

export default AuthRepInfo;
